import { useCampaignStore } from '@/src/store/campaign';

export interface Distribution {
  id: string;
  votes: number;
  votes_percentage?: string; // This is optional, as it's added by the function
}

export function getDistribution(votes: Distribution[]): Distribution[] {
  const myVotes = getMyAnswers();

  myVotes.forEach((voteId) => {
    const voteIndex = votes.findIndex((vote) => vote.id.toString() === voteId);
    if (voteIndex !== -1) {
      // eslint-disable-next-line security/detect-object-injection
      votes[voteIndex].votes += 1;
    } else {
      votes.push({ id: voteId, votes: 1 });
    }
  });

  return roundPercentages(votes);
}

function roundPercentages(values: Distribution[]): Distribution[] {
  const total = values
    .sort(function (a, b) {
      // @ts-ignore
      return a.id - b.id;
    })
    .map(function (val) {
      return val.votes;
    })
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  const pPercent = total / 100;
  let i = 0;
  const length = values.length;
  let sumCurrent = 0;

  values = values.map(function (val) {
    if (total === 0) {
      val.votes_percentage = '0.0';
    } else {
      i++;

      let percent = parseFloat(
        parseFloat(val.votes / pPercent + '')
          .toFixed(3)
          .slice(0, -2)
      );

      if (i === length && sumCurrent + percent < 100) {
        percent += 100 - (sumCurrent + percent);
      }

      sumCurrent += percent;
      val.votes_percentage = parseFloat(percent + '').toFixed(1);
    }

    return val;
  });

  return values;
}

export function getMyAnswers(): string[] {
  const campaignStore = useCampaignStore();
  const answers: string[] = [];

  if (campaignStore.metricData.answer) {
    return [campaignStore.metricData.answer.toString()];
  }

  for (const key in campaignStore.metricData) {
    if (Object.prototype.hasOwnProperty.call(campaignStore.metricData, key)) {
      // eslint-disable-next-line security/detect-object-injection
      const element = campaignStore.metricData[key];
      if (element) {
        const id = key.replace('answer_', '');

        answers.push(id);
      }
    }
  }

  return answers;
}
